import { useAuth } from './../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { checkForSuperAdmin } from '../../utils/checkRole';

export const SuperAdminGuard = ({ children }) => {
    const { currentUser } = useAuth();
    const hasPermission = checkForSuperAdmin(currentUser);
    return hasPermission ? children : <Navigate to={'/dashboard'} />;
};
